import { useCallback } from 'react';
import { useTranslations } from 'next-intl';

export function useLogFormatters() {
  const t = useTranslations('systemLogs');

  const translateAction = useCallback(
    (action: string): string => {
      const key = `actions.${action}` as Parameters<typeof t>[0];
      return t.has(key) ? t(key) : action;
    },
    [t]
  );

  const translateSubjectType = useCallback(
    (subjectType: string): string => {
      const key = `subjectTypes.${subjectType}` as Parameters<typeof t>[0];
      return t.has(key) ? t(key) : subjectType;
    },
    [t]
  );

  return { translateAction, translateSubjectType };
}
